import React from 'react'
import {REWARD_CARD_TYPES, REWARD_TYPES, isInventoryManagedRewardType} from '@/utils/constants/rewardsConstants'
import InventorySection from './InventorySection'
import ToggleRow from './ToggleRow'
import InventorySectionForCardTypeBoth from './InventorySectionForCardTypeBoth'
import {Constants} from '@/utils/constants/commonConstants'
import { useAdditionalAttributesLogic } from './useAdditionalAttributesSection-hook'

/**
 * AdditionalAttributesSection component for reward display and stock settings
 * @param {Object} props - Component props
 * @param {Object} props.formData - Form data containing displayOutOfStock, inStock, and inventory fields
 * @param {Function} props.handleFormChange - Function to handle form field changes
 * @param {Function} props.handleValidation - Function to handle validation state
 * @returns {JSX.Element} The rendered AdditionalAttributesSection component
 */
const AdditionalAttributesSection = ({formData, handleFormChange, handleValidation, validation}) => {
  const {
    handleQuotaChange,
    handleLeftoverInventoryChange,
    handleLimitPerStoreChange,
    handleMaxQuantityPerOrderChange,
    handleQuotaDigitalCardChange,
    handleLeftoverInventoryDigitalCardChange,
    handleLimitPerStoreDigitalCardChange,
    handleQuotaPhysicalCardChange,
    handleLeftoverInventoryPhysicalCardChange,
    handleLimitPerStorePhysicalCardChange,
     handleDisplayOutOfStockChange,
    handleUnlimitedInventoryChange,
    handleInStockChange,
  } = useAdditionalAttributesLogic({formData, handleFormChange, handleValidation, validation})

  // Check if reward type supports inventory
  const inventoryRewardType = isInventoryManagedRewardType(formData?.rewardType, formData?.rewardCardType)

  const isInventoryVisaCardTypeBoth =
    formData?.rewardType === REWARD_TYPES.VISA_CARD && formData?.rewardCardType === REWARD_CARD_TYPES.Both

  return (
    <div className="flex flex-col gap-6">
      <h3 className="text-base font-bold text-white">Additional Attributes</h3>

      {/* Show InventoryFieldsRow for inventory reward types */}
      {inventoryRewardType && (
        <InventorySection
          formData={formData}
          handleFormChange={handleFormChange}
          handleValidation={handleValidation}
          handleQuotaChange={handleQuotaChange}
          handleLeftoverInventoryChange={handleLeftoverInventoryChange}
          handleLimitPerStoreChange={handleLimitPerStoreChange}
          handleMaxQuantityPerOrderChange={handleMaxQuantityPerOrderChange}
          isQuotaDisabled={formData?.leftoverInventory == Constants.Unlimited}
          quotaValidationError={validation?.quotaValid}
          limitValidationError={validation?.limitPerStoreValid}
          maxQuantityPerOrderValidationError={validation?.maxQuantityPerOrderValid}
        />
      )}

      {/* Show InventoryFieldsRowForCardTypeBoth for Visa Card - Both */}
      {isInventoryVisaCardTypeBoth && (
        <InventorySectionForCardTypeBoth
          formData={formData}
          handleFormChange={handleFormChange}
          handleValidation={handleValidation}
          handleQuotaDigitalCardChange={handleQuotaDigitalCardChange}
          handleLeftoverInventoryDigitalCardChange={handleLeftoverInventoryDigitalCardChange}
          handleLimitPerStoreDigitalCardChange={handleLimitPerStoreDigitalCardChange}
          handleQuotaPhysicalCardChange={handleQuotaPhysicalCardChange}
          handleLeftoverInventoryPhysicalCardChange={handleLeftoverInventoryPhysicalCardChange}
          handleLimitPerStorePhysicalCardChange={handleLimitPerStorePhysicalCardChange}
          isQuotaDigitalCardDisabled={formData?.leftoverInventoryDigitalCard == Constants.Unlimited}
          isQuotaPhysicalCardDisabled={formData?.leftoverInventoryPhysicalCard == Constants.Unlimited}
          quotaDigitalCardValidationError={validation?.quotaDigitalCardValid}
          quotaPhysicalCardValidationError={validation?.quotaPhysicalCardValid}
          limitPerStoreDigitalCardValidationError={validation?.limitPerStoreDigitalCardValid}
          limitPerStorePhysicalCardValidationError={validation?.limitPerStorePhysicalCardValid}

        />
      )}

      {/* ToggleRow - Always shown, conditionally shows unlimited inventory toggle based on reward type */}
      <ToggleRow
        formData={formData}
        handleDisplayOutOfStockChange={handleDisplayOutOfStockChange}
        handleUnlimitedInventoryChange={handleUnlimitedInventoryChange}
        handleInStockChange={handleInStockChange}
      />
    </div>
  )
}

export default AdditionalAttributesSection
